import script from "./ReplaceScopeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReplaceScopeDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReplaceScopeDialog.vue?vue&type=style&index=0&id=33f7d2ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f7d2ea"]])

export default __exports__